export var VERSION = '1.25.0';
//# sourceMappingURL=version.js.map